import { render, staticRenderFns } from "./FairPayCalculatorAtEffectiveDateCard.vue?vue&type=template&id=3d53e020&scoped=true"
import script from "./FairPayCalculatorAtEffectiveDateCard.vue?vue&type=script&setup=true&lang=js"
export * from "./FairPayCalculatorAtEffectiveDateCard.vue?vue&type=script&setup=true&lang=js"
import style0 from "./FairPayCalculatorAtEffectiveDateCard.vue?vue&type=style&index=0&id=3d53e020&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d53e020",
  null
  
)

export default component.exports